import type { BadgeVariant } from '@/components/badge/badge';

export const MENTOR_DISCIPLINE_STATUS = {
  NORMAL: 1,
  WARNED: 2,
  SUSPENDED: 3,
} as const;

export type MentorDisciplineStatus =
  (typeof MENTOR_DISCIPLINE_STATUS)[keyof typeof MENTOR_DISCIPLINE_STATUS];

const LABELS: Record<number, string> = {
  1: 'Normal',
  2: 'Peringatan',
  3: 'Ditangguhkan',
};

const VARIANTS: Record<number, BadgeVariant> = {
  1: 'success',
  2: 'warning',
  3: 'destructive',
};

export function getMentorDisciplineStatusLabel(status?: number | null) {
  if (status == null) return '-';
  return LABELS[status] ?? `Tidak dikenal (${status})`;
}

export function getMentorDisciplineStatusVariant(
  status?: number | null
): BadgeVariant {
  if (status == null) return 'neutral';
  return VARIANTS[status] ?? 'neutral';
}

export const MENTOR_DISCIPLINE_STATUS_OPTIONS = [
  { value: '1', label: 'Normal' },
  { value: '2', label: 'Peringatan' },
  { value: '3', label: 'Ditangguhkan' },
];
